// src/services/authService.js
import apiClient from './apiClient.js'

export const authService = {
    login(credentials) {
        return apiClient.post('/auth/login', credentials)
    },

    getCurrentUser() {
        return apiClient.get('/auth/me')
    },
}